export default __webpack_public_path__ + "static/media/highlight-alt.60c4942b.svg";